var _templateObject = _taggedTemplateLiteralLoose(['\n  background-color: ', ';\n  border: 1px solid ', ';\n  color: ', ';\n  padding: 12px 24px 12px 24px;\n  cursor: pointer;\n  text-transform: uppercase;\n  font-weight: bold;\n  border-radius: 4px;\n  transition: all 0.25s ease-in-out;\n  font-size: 14px;\n  &:hover {\n    box-shadow: 0 2px 1px rgba(0,0,0,0.02),\n    0 4px 2px rgba(0,0,0,0.02),\n    0 8px 4px rgba(0,0,0,0.02),\n    0 16px 8px rgba(0,0,0,0.02),\n    0 32px 16px rgba(0,0,0,0.02);\n  }\n'], ['\n  background-color: ', ';\n  border: 1px solid ', ';\n  color: ', ';\n  padding: 12px 24px 12px 24px;\n  cursor: pointer;\n  text-transform: uppercase;\n  font-weight: bold;\n  border-radius: 4px;\n  transition: all 0.25s ease-in-out;\n  font-size: 14px;\n  &:hover {\n    box-shadow: 0 2px 1px rgba(0,0,0,0.02),\n    0 4px 2px rgba(0,0,0,0.02),\n    0 8px 4px rgba(0,0,0,0.02),\n    0 16px 8px rgba(0,0,0,0.02),\n    0 32px 16px rgba(0,0,0,0.02);\n  }\n']);

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import React from 'react';
import styled from 'styled-components';
var B = styled.button(_templateObject, function (props) {
  return props.backgroundcolour;
}, function (props) {
  return props.bordercolour;
}, function (props) {
  return props.textcolour;
});

var Button = function Button(props) {
  var backgroundcolour = props.backgroundcolour,
      textcolour = props.textcolour,
      bordercolour = props.bordercolour,
      onClick = props.onClick;
  var buttonBackgroundcolour = backgroundcolour || '#AF144B';
  var buttonTextcolour = textcolour || '#FFF';
  var buttonBordercolour = bordercolour || 'transparent';
  return React.createElement(B, {
    backgroundcolour: buttonBackgroundcolour,
    textcolour: buttonTextcolour,
    bordercolour: buttonBordercolour,
    onClick: onClick
  }, props.children);
};

export default Button;